import { useCallback } from 'react';
import { useShieldPRDTelemetry } from 'App/ShieldPRD/useShieldPRDTelemetry';
import { FeatureFlag } from 'Environment/FeatureFlag';
import { ChromeAppContext } from 'Workspace/ChromeApp/ChromeAppContext';
import { useChromeApp } from 'Workspace/ChromeApp/useChromeApp';

export const useShieldPRDTelemetryForChromeApp = () => {
	const context = useChromeApp();
	const getExtraPayload = useCallback(async (_context: ChromeAppContext) => {
		const { getChromeAppConfiguration } = _context;
		const isChromeApp = true;
		const config = await getChromeAppConfiguration();
		const cwaVersion = config?.platform?.buildVersion;
		const deviceId = config?.platform?.deviceId;
		const supportsGetAndResetShieldStateInformationForAnalytics =
			config.supportsGetAndResetShieldStateInformationForAnalytics ?? false;
		return {
			isChromeApp,
			supportsGetAndResetShieldStateInformationForAnalytics,
			cwaVersion,
			deviceId,
		};
	}, []);
	return useShieldPRDTelemetry({
		featureFlag: FeatureFlag.WSUI10821EnableChromeAppShieldPRDTelemetry,
		context,
		getExtraPayload,
	});
};
